var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page-table',{attrs:{"apiName":_vm.apiName,"nameRole":_vm.nameRoleEntity,"titleTable":_vm.$t('Поставщики'),"paramsGetData":_vm.paramsGetData,"fieldLand":_vm.fieldLang,"keyTable":'id',"deleteParams":_vm.deleteParams,"apiDeleteName":_vm.apiDeleteName,"alternativeConverter":_vm.convertData,"isDefaultConverter":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }